/* eslint-disable @typescript-eslint/no-explicit-any */
import { CircularProgress } from '@mui/material';
import { useNetworkContext } from '../../network';
import './cart-sync-and-checkout.scss';
import { getAllCustomersCart, useAppSelector } from '@zonofi/zono-money-store';
import { ReactComponent as InfoIcon } from '@zonofi/svg-icons/input-info.svg';
import { CommonButton } from '../../components';

interface CartSyncAndCheckoutProps {
  isSynced: boolean;
  hasOutOfStockItem: boolean;
  addItemToActiveOrderAPIResponse: any;
  cartCheckoutAPIResponse: any;
  onClickSync: () => void;
  onClickCheckout: () => void;
  onNotifyBuyer: () => void;
  notifyBuyerApiResponse: any;
}

export const CartSyncAndCheckout: React.FC<CartSyncAndCheckoutProps> = ({
  isSynced,
  hasOutOfStockItem,
  addItemToActiveOrderAPIResponse,
  cartCheckoutAPIResponse,
  onClickSync,
  onClickCheckout,
  onNotifyBuyer,
  notifyBuyerApiResponse,
}) => {
  const { networkStatus } = useNetworkContext();
  const disablePrimaryAction = !networkStatus || hasOutOfStockItem;
  return isSynced ? (
    <div className="offline-cart-button-section">
      {hasOutOfStockItem && (
        <div className="offline-cart-button-section-oos-warning">
          <InfoIcon color="#fff" />
          <span className="font-semibold">
            Your cart contains an out-of-stock item. Please replace or remove it
            to continue.
          </span>
        </div>
      )}

      <div className="offline-cart-button-section-view">
        <CommonButton
          text="Ask Confirmation"
          onPress={onNotifyBuyer}
          buttonStyle={`sync-confrim-button-view`}
          disabled={hasOutOfStockItem}
          spinnerColor={'white'}
          spinnerStyle="sync-accept-button-view-spinner"
          loading={notifyBuyerApiResponse.isLoading}
          spinnerSize={20}
        />
        <CommonButton
          text={'Checkout'}
          buttonStyle={`sync-accept-button-view ${
            disablePrimaryAction ? 'disabled' : ''
          }`}
          disabled={disablePrimaryAction}
          onPress={onClickCheckout}
          spinnerStyle="sync-accept-button-view-spinner"
          spinnerColor={'white'}
          spinnerSize={20}
          loading={cartCheckoutAPIResponse.isLoading}
        />
      </div>
    </div>
  ) : (
    <div className="offline-cart-button-section">
      <div className="offline-cart-button-section-warning">
        <span className="font-semibold">
          {`Amount are only a cart estimate.${networkStatus ? '' : ' Connect to the internet and'} Click
          ‘Sync’ to fetch the actual details and values.`}
        </span>
      </div>
      {hasOutOfStockItem && (
        <div className="offline-cart-button-section-oos-warning">
          <InfoIcon color="#fff" />
          <span className="font-semibold">
            Your cart contains an out-of-stock item. Please replace or remove it
            to continue.
          </span>
        </div>
      )}
      <div
        className="offline-cart-button-section-sync"
        aria-disabled={addItemToActiveOrderAPIResponse?.isLoading}
      >
        <button
          className={`offline-cart-button-section-sync-button ${disablePrimaryAction ? 'disabled' : ''} font-bold`}
          onClick={onClickSync}
          disabled={disablePrimaryAction}
        >
          {addItemToActiveOrderAPIResponse?.isLoading ? (
            <CircularProgress size={20} style={{ color: '#fff' }} />
          ) : (
            'Sync Cart'
          )}
        </button>
      </div>
    </div>
  );
};
